import cn from 'classnames'

import { Translation } from 'cng-common/features/translations'
import { Tooltip } from 'core-components/library/tooltip'
import { TRANSLATION_KEYS } from 'partner360/features/keyInitiatives/configs/translations'

import { getListPeriodKey, getListQuarters, LIST_QUARTERS } from '../../helpers/listPeriod'

import styles from './InitiativePeriod.module.scss'

export const InitiativePeriod = ({ period }: { period?: string | null }) => {
  const quarters = getListQuarters(period)
  const label = getListPeriodKey(period)
  const translations = TRANSLATION_KEYS.listView.period
  const labelKey =
    label === 'full-year'
      ? translations.fullYear
      : label === 'h1'
        ? translations.h1
        : label === 'h2'
          ? translations.h2
          : null
  if (!quarters.length) return <span className={styles.empty}>-</span>
  return (
    <div className={styles.root}>
      <div className={styles.strip} aria-hidden="true">
        {LIST_QUARTERS.map((quarter) => (
          <Tooltip key={quarter} inline tipContent={() => <span>{quarter}</span>}>
            <i className={cn(styles.quarter, { [styles.active]: quarters.includes(quarter) })} />
          </Tooltip>
        ))}
      </div>
      <span>{labelKey ? <Translation text={labelKey} span /> : quarters.join(', ')}</span>
    </div>
  )
}
